// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"612":"security-policy","981":"documents"}[chunkId] + "." + {"612":"0b01ae0e","981":"e92e6a09"}[chunkId] + ".js";
};